import {ADS_LIST_TAGCLOUD_PER_OFFER_TYPE, SEARCH_SECTION_IDS, TAGCLOUD_ENDPOINTS} from '../base.js'

export const TAGCLOUD_ENDPOINTS_FROM_PAGE_NAME = {
  HTTPSeoRepository: {
    home: TAGCLOUD_ENDPOINTS.default,
    'ads-list': ADS_LIST_TAGCLOUD_PER_OFFER_TYPE,
    'ads-list-vans-and-commercial': TAGCLOUD_ENDPOINTS.default,
    'ads-list-classic-and-competition': TAGCLOUD_ENDPOINTS.default,
    'ads-list-autocaravans-and-trailers': TAGCLOUD_ENDPOINTS.default,
    'ads-list-cars-without-license': TAGCLOUD_ENDPOINTS.default,
    'ads-list-quads': TAGCLOUD_ENDPOINTS.default,
    'ads-list-buggies': TAGCLOUD_ENDPOINTS.default,
    'ads-list-minimotos': TAGCLOUD_ENDPOINTS.default,
    'ads-list-new': TAGCLOUD_ENDPOINTS.newVehicles,
    'ads-list-quads-new': TAGCLOUD_ENDPOINTS.default,
    'ads-list-buggies-new': TAGCLOUD_ENDPOINTS.default,
    'ads-list-minimotos-new': TAGCLOUD_ENDPOINTS.default,
    'ads-list-classic-and-competition-new': TAGCLOUD_ENDPOINTS.default,
    'ads-detail': TAGCLOUD_ENDPOINTS.wdyl,
    'news-category': TAGCLOUD_ENDPOINTS.make,
    'vehicles-grid': TAGCLOUD_ENDPOINTS.wdyl,
    'news-comments': TAGCLOUD_ENDPOINTS.news,
    'news-detail': TAGCLOUD_ENDPOINTS.news,
    'vehicle-detail': TAGCLOUD_ENDPOINTS.wdyl,
    'news-tag': TAGCLOUD_ENDPOINTS.make,
    'news-search': TAGCLOUD_ENDPOINTS.make,
    'news-section-tips': TAGCLOUD_ENDPOINTS.make,
    'news-section-trends': TAGCLOUD_ENDPOINTS.make,
    'technical-details-make': {
      ...TAGCLOUD_ENDPOINTS.stock,
      params: {
        ...TAGCLOUD_ENDPOINTS.stock.params,
        searchSectionId: SEARCH_SECTION_IDS.make
      }
    },
    'technical-details-model': {
      ...TAGCLOUD_ENDPOINTS.stock,
      params: {
        ...TAGCLOUD_ENDPOINTS.stock.params,
        searchSectionId: SEARCH_SECTION_IDS.model
      }
    },
    'technical-details-body-type': TAGCLOUD_ENDPOINTS.stock,
    'technical-details-version': TAGCLOUD_ENDPOINTS.stock,
    'technical-details-vehicle': TAGCLOUD_ENDPOINTS.stock,
    'technical-details-vehicle-without-version': TAGCLOUD_ENDPOINTS.stock
  }
}

export const ALLOWED_TAGCLOUD_VERSION_PARAMS = []
